import Icon from '@ant-design/icons/lib/components/Icon';
import { Button, Result } from 'antd';
import React from 'react';
import { Sentry } from '@guuru/sentry-web';
import ImageSvg from './Error_500.svg';

interface ErrorPageProps {
  eventId?: string;
}

const ErrorPage = function ({ eventId }: ErrorPageProps = {}) {
  return (
    <Result
      icon={<Icon component={ImageSvg} style={{ fontSize: '300px' }} />}
      status={404}
      title="Oops"
      subTitle="An unexpected error seems to have occurred."
      extra={
        <Button
          type="primary"
          onClick={() => Sentry.showReportDialog({ eventId })}
        >
          Report feedback
        </Button>
      }
    />
  );
};

export default ErrorPage;
